var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showAsync)?_c('async-component',{attrs:{"url":_vm.url},on:{"execute-axios":_vm.executeAxios,"on-add-languanges":_vm.addLanguages,"plugin-call-back":_vm.pluginCallBack}}):_c('div',[_c('h1',[_vm._v("未知组件无法展示")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }